import { ManageCell } from 'src/common/DataGrid/ManageCell';
import { PayerPassengerRead } from 'src/common/external/bambi-api/bambiApi';
import { useModal } from 'src/common/modals/useModal';

import { PayerPassengerEditModal } from './PayerPassengerEditModal';

interface PayerPassengerManageCellProps {
  payerPassenger: PayerPassengerRead;
  onAfterSave: () => void;
}

export function PayerPassengerManageCell({
  payerPassenger,
  onAfterSave,
}: PayerPassengerManageCellProps) {
  const { open, setOpen, closeModal } = useModal();

  return (
    <>
      <ManageCell
        items={[
          {
            label: 'Edit',
            icon: 'pencil',
            onClick: () => setOpen(true),
          },
        ]}
      />
      {open && (
        <PayerPassengerEditModal
          open={open}
          setOpen={setOpen}
          onClose={(saved: boolean) => {
            closeModal();
            if (saved) {
              onAfterSave();
            }
          }}
          payerPassenger={payerPassenger}
        />
      )}
    </>
  );
}
